import { FabricHub } from '../hub.jsy'
export default FabricHub.plugin()

